const initialState = {
  AllTVChannelData: [],
  TVDataID: [],
  CurrentTVData: [],
  AllEPGData: [],
  isLoading: false,
  isLiveTvInfoLoading: false,
  isLiveTvLoading: false,
};

const liveTvChannelReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLEAR_REDUCER_STATE":
      return {
        ...initialState,
      };
    case "LIVE_TV_CHANNEL":
      return {
        ...state,
        AllTVChannelData: action.payload,
      };
    case "LIVE_TV_CHANNEL_ID":
      return {
        ...state,
        TVDataID: action.payload,
      };
    case "CURRENT_LIVE_TV_DATA":
      return {
        ...state,
        CurrentTVData: action.payload,
      };
    case "ALL_EPG_DATA":
      return {
        ...state,
        AllEPGData: action.payload,
      };
    case "LOADING_START":
      return {
        ...state,
        isLoading: true,
      };
    case "LOADING_END":
      return {
        ...state,
        isLoading: false,
      };
    case "LOADING_START_CHANNEL":
      return {
        ...state,
        isLiveTvLoading: true,
      };
    case "LOADING_END_CHANNEL":
      return {
        ...state,
        isLiveTvLoading: false,
      };
    case "LIVE_TV_INFO_LOADING_START":
      return {
        ...state,
        isLiveTvInfoLoading: true,
      };
    case "LIVE_TV_INFO_LOADING_END":
      return {
        ...state,
        isLiveTvInfoLoading: false,
      };
    default:
      return state;
  }
};

export default liveTvChannelReducer;
